import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../components/ActionButton'; 
import { authenticateTmpEmail } from '../../api/BackendApi.jsx';

const MAX_ALLOWED_LENGTH = 255;

const EnterEmailStep = ({ onEmailSuccess }) => {
  const navigate = useNavigate();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  // Simple Email Regex Validation
  const isValidEmailFormat = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleOnNext = async () => {
      setError(null);

      if (!email.trim()) {
          setError('Prosím zadejte e-mailovou adresu.');
          return;
      }
      
      if (!isValidEmailFormat(email)) {
          setError('Zadaný e-mail nemá platný formát.');
          return;
      }

      if (email.length > MAX_ALLOWED_LENGTH) {
          setError(`E-mail je příliš dlouhý (max ${MAX_ALLOWED_LENGTH} znaků).`);
          return;
      }
  
      setIsSubmitting(true);
      try {
        await authenticateTmpEmail(email); 
        if (onEmailSuccess) {
          await onEmailSuccess();
        }
        navigate(`/analysis/create`);
      } catch (err) {
        setError(err.message || 'Nastala chyba při ověřování e-mailu.');
      } finally {
        setIsSubmitting(false);
      }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isSubmitting && termsAccepted) {
      handleOnNext();
    }
  };

  const inputClasses = `
    w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 transition-shadow duration-200
    ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-blue-500'}
    ${isSubmitting ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-900'}
  `;

  return(
  <>
    <div className="flex justify-center min-h-full p-4 pt-8 pb-16">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl p-8 md:p-12 transform transition-all duration-500">
        <div className="flex flex-col items-center"></div>

          <div className="w-full text-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Zadejte e-mailovou adresu</h2>
          </div>

          <div className="w-full mb-4">
            <label htmlFor="email" className="block text-lg font-semibold text-gray-700 mb-2">
              Zadejte e-mailovou adresu, na kterou odešleme výsledek:
            </label>
            
            {/* Changed Textarea to Input for better Email UX */}
            <input
              id="email"
              type="email"
              className={inputClasses}
              value={email}
              onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError(null); // Clear error when user types
              }}
              onKeyDown={handleKeyDown}
              placeholder="jan.novak@example.com"
              disabled={isSubmitting}
              maxLength={MAX_ALLOWED_LENGTH}
            />

            <div className="flex justify-between items-start mt-2 text-sm">
                {/* Error Message Area */}
                <div className="flex-1">
                  {error && (
                      <p className="text-red-600 font-medium">
                        {error}
                      </p>
                  )}
                </div>
            </div>
          </div>

          {/* Checkbox a varování */}
          <div className="w-full flex flex-col items-center mb-4">
            <label className="flex items-center gap-3 cursor-pointer text-sm text-gray-700">
              <input 
                type="checkbox" 
                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500 cursor-pointer"
                checked={termsAccepted}
                onChange={(e) => {
                  setTermsAccepted(e.target.checked);
                }}
              />
              <span>
                Souhlasím s <a href="/terms" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Obchodními podmínkami</a> a se <a href="/zasady-cookies" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">Zásadami zpracování osobních údajů</a>
              </span>
            </label>
          </div>

          <ActionButton 
              onClick={handleOnNext} 
              disabled={isSubmitting || !email || !termsAccepted}
              isLoading={isSubmitting}
          >
            {isSubmitting ? 'Ověřování...' : 'Pokračovat'}
          </ActionButton>
      </div>
    </div>
  </>
);
}
export default EnterEmailStep;